"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaJson = void 0;
const serialize_1 = require("./methods/serialize");
const deserialize_1 = require("./methods/deserialize");
// type TFunction<T> = ObjectConstructor["constructor"] & TConstructor<T>;
class TaJson {
    static deserialize(object, type, options) {
        return deserialize_1.deserialize(object, type, options);
    }
    static parse(json, type, options) {
        return this.deserialize(JSON.parse(json), type, options);
    }
    static serialize(value, options) {
        return serialize_1.serialize(value, undefined, options);
    }
    static stringify(object, options) {
        return JSON.stringify(this.serialize(object, options));
    }
}
exports.TaJson = TaJson;
